import ReactMarkdown from "react-markdown";
import PropTypes from "prop-types";

import { COLOR_VALUES } from "shared/config/colors";
import { VARIANTS } from "./Text";
import { StyledText } from "./RichText.styles";

const RichText = ({ variant, color, children, ...rest }) => {
    return (
        <StyledText $variant={variant} $color={color} {...rest}>
            <ReactMarkdown>{children}</ReactMarkdown>
        </StyledText>
    );
};

RichText.propTypes = {
    variant: PropTypes.oneOf(Object.values(VARIANTS)),
    color: PropTypes.oneOf(Object.keys(COLOR_VALUES)),
    children: PropTypes.node,
};

export default RichText;
